import type { WFaqTranslations } from "./pl";

export const en: WFaqTranslations = {
  defaultTitle: "Frequently asked questions",
};
